import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./trainerPortal.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function TrainerEducation() {
  const [universityName, setUniversityName] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [qualification, setQualification] = useState("");
  const [yearOfStarting, setYearOfStarting] = useState("");
  const [yearOfPassing, setYearOfPassing] = useState("");
  const [percentage, setPercentage] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [educationOptions, setEducationOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEducationOptions = async () => {
      try {
        const response = await AxiosInstance.get(
          "companies/educations/"
        );
        if (response.status === 200) {
          setEducationOptions(response.data);
        } else {
          setErrorMessage("Failed to fetch education options.");
        }
      } catch (error) {
        console.error("Error fetching education options:", error);
        setErrorMessage("Failed to fetch education options.");
      }
    };

    fetchEducationOptions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trainerId = localStorage.getItem("trainerId");
    if (!trainerId) {
      setErrorMessage("Trainer not logged in.");
      return;
    }

    const education = educationOptions.find(
      (option) => option.qualification === qualification
    );
    if (!education) {
      setErrorMessage("Please select a valid qualification.");
      return;
    }

    const newEducation = {
      trainer: trainerId,
      education: education.education_id,
      specialization,
      college_name: collegeName,
      university: universityName,
      year_of_starting: yearOfStarting,
      year_of_passing: yearOfPassing,
      percentage_or_cgpa: parseFloat(percentage),
    };

    try {
      const response = await AxiosInstance.post(
        "companies/user/educations/",
        newEducation
      );

      if (response.status === 201) {
        alert("Education added successfully!");
        navigate(-1);
      } else {
        setErrorMessage("Something went wrong.");
      }
    } catch (error) {
      console.error("Error adding education:", error);
      setErrorMessage("Failed to add education.");
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <div
      className="modal d-block als-trainer-portal"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Education</h5>
          </div>
          <div className="modal-body">
            {errorMessage && (
              <div className="alert alert-danger" role="alert">
                {errorMessage}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">University Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={universityName}
                  onChange={(e) => setUniversityName(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">College Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={collegeName}
                  onChange={(e) => setCollegeName(e.target.value)}
                />
              </div>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Qualification</label>
                  <select
                    className="form-select"
                    value={qualification}
                    onChange={(e) => setQualification(e.target.value)}
                    required
                  >
                    <option value="">Select Qualification</option>
                    {educationOptions.map((education) => (
                      <option
                        key={education.education_id}
                        value={education.qualification}
                      >
                        {education.qualification}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col">
                  <label className="form-label">Specialization</label>
                  <input
                    type="text"
                    className="form-control"
                    value={specialization}
                    onChange={(e) => setSpecialization(e.target.value)}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Year of Starting</label>
                  <input
                    type="date"
                    className="form-control"
                    value={yearOfStarting}
                    onChange={(e) => setYearOfStarting(e.target.value)}
                    required
                  />
                </div>
                <div className="col">
                  <label className="form-label">Year of Passing</label>
                  <input
                    type="date"
                    className="form-control"
                    value={yearOfPassing}
                    onChange={(e) => setYearOfPassing(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Percentage/CGPA</label>
                <input
                  type="text"
                  className="form-control"
                  value={percentage}
                  onChange={(e) => setPercentage(e.target.value)}
                />
              </div>
              <div className="modal-footer px-0">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Education
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
